module.exports = __webpack_public_path__ + "static/media/gochi_jingle_master_final.337d5e3b.mp3";